import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';

@Component({
  selector: 'educational',
  templateUrl: "./educationalform.component.html"
})
export class EducationalFormComponent implements OnInit {
  FeedbackForm: FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid: string;
  @Input() admin_show: string;
  validations_flag = false;
  feedback_message;
  showExperience = false;

  edu_form: FormGroup;
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  semesterValidation = true;
  monthValidation = true;
  yearValidation = true;
  attemptValidation = true;
  instructionValidation = true;
  edu_data;
  course_data;
  user: any;

  constructor(protected api: ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    protected ref: NbDialogRef<EducationalFormComponent>) { }

  async ngOnInit() {
    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: ['', Validators.required],
      collegeYearCtrl: ['', Validators.required],
      semesterCtrl: ['', Validators.required],
      monthCtrl: ['', Validators.required],
      yearCtrl: ['', Validators.required],
      attemptCtrl: ['', Validators.required],
      overAllGradeCtrl: ['', Validators.required],
      overAllYearlyGradeCtrl: [''],
      subjectFirstCtrl: ['', Validators.required],
      markFirstCtrl: ['', Validators.required],
      subjectSecondCtrl: ['', Validators.required],
      markSecondCtrl: ['', Validators.required],
      subjectThirdCtrl: ['', Validators.required],
      markThirdCtrl: ['', Validators.required],
      subjectFourthCtrl: ['', Validators.required],
      markFourthCtrl: ['', Validators.required],
      subjectFifthCtrl: [''],
      markFifthCtrl: [''],
      subjectSixthCtrl: [''],
      markSixthCtrl: [''],
      subjectSeventhCtrl: [''],
      markSeventhCtrl: [''],
      subjectEighthCtrl: [''],
      markEighthCtrl: [''],
      specialInstrctionCtrl: [''],
      instructionCtrl: ['', Validators.required],
    })

    this.api.getCouses()
      .subscribe(
        (data: any) => {
          if (data['status'] == 200) {
            this.course_data = data['data'];

          } else {

          }
        });


    const now = new Date().getUTCFullYear();
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);


    if (this.user_id != null) {
      this.api.getEducation(this.edu_id, this.user_id)
        .subscribe(
          (data: any) => {
            if (data['status'] == 200) {
              this.edu_data = data['data'];

            } else {

            }
          });
    }
  }

  saveEdu() {
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.semesterValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;

    if (this.edu_form.valid == false) {
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      this.edu_form.controls.overAllGradeCtrl.markAsDirty();
      this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      this.edu_form.controls.markSecondCtrl.markAsDirty();
      this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      this.edu_form.controls.markThirdCtrl.markAsDirty();
      this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      this.edu_form.controls.markFourthCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();

      if (this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value === '' || this.edu_form.controls.instructionCtrl.value === undefined) {
        this.instructionValidation = false;
      } else {
        this.instructionValidation = true;
      }

      if (this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value === '' || this.edu_form.controls.courseNameCtrl.value === undefined) {
        this.courseValidation = false;
      } else {
        this.courseValidation = true;
      }

      if (this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value === '' || this.edu_form.controls.collegeYearCtrl.value === undefined) {
        this.collegeYearValidation = false;
      } else {
        this.collegeYearValidation = true;
      }

      if (this.edu_form.controls.semesterCtrl.value === null || this.edu_form.controls.semesterCtrl.value === '' || this.edu_form.controls.semesterCtrl.value === undefined) {
        this.semesterValidation = false;
      } else {
        this.semesterValidation = true;
      }

      if (this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value === '' || this.edu_form.controls.monthCtrl.value === undefined) {
        this.monthValidation = false;
      } else {
        this.monthValidation = true;
      }

      if (this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value === '' || this.edu_form.controls.yearCtrl.value === undefined) {
        this.yearValidation = false;
      } else {
        this.yearValidation = true;
      }

      if (this.edu_form.controls.attemptCtrl.value === null || this.edu_form.controls.attemptCtrl.value === '' || this.edu_form.controls.attemptCtrl.value === undefined) {
        this.attemptValidation = false;
      } else {
        this.attemptValidation = true;
      }
    } else {
      var edu_data = {
        courseName: this.edu_form.controls.courseNameCtrl.value,
        collegeYear: this.edu_form.controls.collegeYearCtrl.value,
        semester: this.edu_form.controls.semesterCtrl.value,
        month: this.edu_form.controls.monthCtrl.value,
        year: this.edu_form.controls.yearCtrl.value,
        attempt: this.edu_form.controls.attemptCtrl.value,
        overAllGrade: this.edu_form.controls.overAllGradeCtrl.value,
        overAllYearlyGrade: this.edu_form.controls.overAllYearlyGradeCtrl.value,
        subjectFirst: this.edu_form.controls.subjectFirstCtrl.value,
        markFirst: this.edu_form.controls.markFirstCtrl.value,
        subjectSecond: this.edu_form.controls.subjectSecondCtrl.value,
        markSecond: this.edu_form.controls.markSecondCtrl.value,
        subjectThird: this.edu_form.controls.subjectThirdCtrl.value,
        markThird: this.edu_form.controls.markThirdCtrl.value,
        subjectFourth: this.edu_form.controls.subjectFourthCtrl.value,
        markFourth: this.edu_form.controls.markFourthCtrl.value,
        subjectFifth: this.edu_form.controls.subjectFifthCtrl.value,
        markFifth: this.edu_form.controls.markFifthCtrl.value,
        subjectSixth: this.edu_form.controls.subjectSixthCtrl.value,
        markSixth: this.edu_form.controls.markSixthCtrl.value,
        subjectSeventh: this.edu_form.controls.subjectSeventhCtrl.value,
        markSeventh: this.edu_form.controls.markSeventhCtrl.value,
        subjectEighth: this.edu_form.controls.subjectEighthCtrl.value,
        markEighth: this.edu_form.controls.markEighthCtrl.value,
        user_id: this.user_id,
        medium_instruction: this.edu_form.controls.instructionCtrl.value,
        special_instruction: this.edu_form.controls.specialInstrctionCtrl.value,
        id: this.edu_id,
      }

      this.api.setEducationalValues(edu_data)
        .subscribe(
          (data: any) => {
            this.ref.close(data);
            err => console.error(err)
          });
    }
  }

  dismiss() {
    this.ref.close();
  }

}